/**
 * like debounceTime in RxJS, but not for observables
 */
export function debounce(func, timeout?: number) {
  let timer;
  return (...args: any[]) => {
    const next = () => func(...args);
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(next, timeout > 0 ? timeout : 300);
  };
}
